import React from 'react';

import './Socials.scss';

const Socials = props => {
    const hostURL = window.location.host;
    const pathURL = window.location.pathname;

    return (
        <div className='Socials'>
            <div className="Socials__text">
                Share
            </div>
            <a rel='noreferrer' target="_blank" href={`mailto:?subject=Outcome-centric%20service%20assessment%20results&body=I%20took%20a%20quick%20assessment%20on%20our%20outcome-centric%20service%20capabilities%20at%20%5Bhttps://${hostURL}${pathURL}%5D.%20Give%20it%20a%20try%20and%20share%20your%20results.`} className="Socials__icon Socials__icon--1"></a>
            <a rel='noreferrer' href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`} className="Socials__icon Socials__icon--4" target="_blank">
            </a>    
            <a rel='noreferrer' href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=Are%20you%20on%20the%20path%20to%20sales%20success?%20I%20just%20took%20a%20quick-self%20assessment%20by%20Oracle%20Advertising%20and%20Customer%20Expereince%20to%20see%20how%20our%20CRM%20strategy%20and%20solutions%20measure%20up%20compared%20to%20our%20competitors%20and%20industry%20standards.%20Give%20it%20a%20try%20and%20share%20your%20results.`} className="Socials__icon Socials__icon--3" target="_blank">    
            </a>    
            <a rel='noreferrer' href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`} target="_blank" className="Socials__icon Socials__icon--2">
            </a>
        </div>    
    )
}

export default Socials;
